module.exports = __webpack_public_path__ + "img/pr-3.e26e9525.png";